import { useState, useEffect, useCallback } from "react";
import { g as getEnvVariable } from "./index-C9TrZnbr.js";
import { useScrollTrigger } from "@mui/material";
const ENVIRONMENTS = {
  DEVELOPMENT: "development",
  PRODUCTION: "production",
  QA: "qa"
};
const useSearchBar = ({ isVisible = false }) => {
  const baseUrl = getEnvVariable({
    currentEnv: ENVIRONMENTS.PRODUCTION,
    // @todo: This variable should be taken from the GlobalHeadContext
    defaultValue: "https://www.quickenloans.com",
    keyToSearch: "APP_BASE_URL"
  });
  const [searchTerm, setSearchTerm] = useState("");
  const handleInputChange = (event) => setSearchTerm(event.value);
  useEffect(() => {
    return () => setSearchTerm("");
  }, [isVisible]);
  return {
    handleInputChange,
    searchTerm,
    searchUrl: `${baseUrl}/search`
  };
};
const useCustomScrollTrigger = () => {
  const [isSystemScroll, setIsSystemScroll] = useState(false);
  const [userInteraction, setUserInteraction] = useState(false);
  const muiTrigger = useScrollTrigger();
  const enableSystemScroll = useCallback((lastScrollPosition) => {
    setIsSystemScroll(true);
    setUserInteraction(false);
    const handleScrollCheck = () => {
      if (window && window.scrollY === lastScrollPosition) {
        window.removeEventListener("scroll", handleScrollCheck);
        setTimeout(() => {
          setIsSystemScroll(false);
        }, 100);
      }
    };
    window.addEventListener("scroll", handleScrollCheck);
  }, []);
  useEffect(() => {
    if (window && !isSystemScroll) {
      const handleUserScroll = () => {
        setUserInteraction(true);
        window.removeEventListener("scroll", handleUserScroll);
      };
      window.addEventListener("scroll", handleUserScroll);
      return () => {
        window.removeEventListener("scroll", handleUserScroll);
      };
    }
  }, [isSystemScroll]);
  const trigger = !muiTrigger || isSystemScroll || !userInteraction;
  return {
    trigger,
    enableSystemScroll
  };
};
export {
  ENVIRONMENTS as E,
  useSearchBar as a,
  useCustomScrollTrigger as u
};
//# sourceMappingURL=useCustomScrollTrigger-DD3As7oF.js.map
